import { Injectable } from '@angular/core';
import { PcoTransactionRequest } from '../components/puntos-colombia/puntos-colombia.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DOC_TYPES } from '../core/constants/FormLists';
import { PCOL_TRANSACTION_KEYS, PCO_NETWORK_CODES } from '../core/constants/General-constants';
import { PaymentMethodsService } from './payment-methods.service';

@Injectable({
  providedIn: 'root'
})
export class PuntosColombiaService {
  private puntosColombiaRegisterUrl = '/puntos-colombia';
  private puntosColombiaHandlerUrl = '/puntos-colombia/remaining-amount';
  private puntosColombiaAcummPointsUrl = '/puntos-colombia/register/accumulation';

  constructor( private http: HttpClient, private readonly paymentMethodService: PaymentMethodsService ) { }

  /**
   * @description request to endpoint that creates the transaction in Puntos Colombia and redirects to its web page
   */
  puntosColombiaRegister(request: PcoTransactionRequest, token: string ) {
    const headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json','CheckoutAuthorization': token }) }

    switch(request.userInformation.documentType){
      case DOC_TYPES.CC.VALUE:
      case DOC_TYPES.CE.VALUE:
        request.userInformation.documentType = PCOL_TRANSACTION_KEYS.PCO_NATURAL_DOC;
        break;
      case DOC_TYPES.NIT.VALUE:
        request.userInformation.documentType = PCOL_TRANSACTION_KEYS.PCO_LEGAL_DOC;
        break;
      default:
        request.userInformation.documentType = PCOL_TRANSACTION_KEYS.PCO_OTHER_TYPE_DOC;
        break;
    }

    return this.http.post(`${environment.urlglobal_api}${this.puntosColombiaRegisterUrl}`, request, headers).toPromise().catch(err => { throw err });
  }

  /**
   * @description request to endpoint that handle the transaction and redirect to voucher or redirect to a new children order in checkout
   * if there is remaining amount left to pay
   */
  puntosColombiaHandler(pcoTransactionId: string, token: string) {
      const headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'CheckoutAuthorization': token }) }

      const request = { externalTransactionId: pcoTransactionId }

      return this.http.post(`${environment.urlglobal_api}${this.puntosColombiaHandlerUrl}`, request, headers).toPromise().catch(err => { throw err });
    }

  /**
   * @description Request to the points Colombia endpoint for the user to accumulate points with the successful transaction performed.
   */
  puntosColombiaAcummPoints(userInfo: any,  token: string) {
      const headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json', CheckoutAuthorization: token }) };

      let completeName: string = '';
      let cellphone: string = '';

      switch(userInfo.typeDI) {
        case DOC_TYPES.CC.VALUE:
        case DOC_TYPES.CE.VALUE:
          userInfo.typeDI = PCOL_TRANSACTION_KEYS.PCO_NATURAL_DOC;
          break;

        case DOC_TYPES.NIT.VALUE:
          userInfo.typeDI = PCOL_TRANSACTION_KEYS.PCO_LEGAL_DOC;
          break;

        default:
          userInfo.typeDI = PCOL_TRANSACTION_KEYS.PCO_OTHER_TYPE_DOC;
          break;
      }

      if (userInfo.cardNumber) {
        completeName = `${userInfo.name} ${userInfo.lastname}`
        cellphone = userInfo.phone_number;
      }


      if (userInfo.bank) {
        completeName = `${userInfo.name} ${userInfo.lastName}`;
        cellphone = userInfo.cellPhone;
      }


      const request: any = {
        userInformation: {
          name: completeName,
          documentType: userInfo.typeDI,
          documentNumber: userInfo.di,
          cellphone: cellphone,
          email: userInfo.email
        }
      }

      this.http.post(`${environment.urlglobal_api}${this.puntosColombiaAcummPointsUrl}`, request, headers).toPromise().catch((_) =>{});
  }

  /**
  * @description Method that checks if the merchant have PCO pay method and request to the points Colombia endpoint for
  * the user to accumulate points with the successful transaction performed.
  */
  pcoCheckAndAcummPoints(pcoTransactionInfo: string[], token: string) {
    this.paymentMethodService.paymentMethods(token).subscribe((paymentMethodRes: any) => {
      const pcoMethod = paymentMethodRes.DATA.paymentMethods.find(method => method.code === PCO_NETWORK_CODES.PCO_NETWORK_CODE);

      if (pcoMethod) {
        this.puntosColombiaAcummPoints(pcoTransactionInfo, token);
      }
    });
  }
}

